import { render, staticRenderFns } from "./BlockSpinner.vue?vue&type=template&id=d0ff34a8&scoped=true&"
import script from "./BlockSpinner.vue?vue&type=script&lang=js&"
export * from "./BlockSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ff34a8",
  null
  
)

export default component.exports